module.exports = __webpack_public_path__ + "static/determined-expanded-1-6c8a078382fba6841655f984c46cfaf0.png";